/**
 * Shared line container — wraps any line-based viewer with:
 *   - Selection bar (shows count, copy, clear)
 *   - Scroll container with ref for spotlight jump-to
 *   - Consistent styling
 */

import React from 'react';
import {LineSelectionState} from './useLineSelection';
import {LineSpotlightState} from './useLineSpotlight';

// ── Selection bar ────────────────────────────────────────────────────────

const SelectionBar: React.FC<{
    selection: LineSelectionState;
}> = ({selection}) => {
    if (selection.selectionCount === 0) return null;
    return (
        <div className="sticky top-0 z-10 flex items-center gap-3 bg-indigo-50 border-b border-indigo-200 px-3 py-1.5 text-xs text-indigo-700">
            <span className="font-medium">
                {selection.selectionCount} line{selection.selectionCount !== 1 ? 's' : ''} selected
            </span>
            <button
                onClick={selection.copySelection}
                className="rounded px-2 py-0.5 bg-indigo-100 hover:bg-indigo-200 transition-colors"
            >
                Copy
            </button>
            <button
                onClick={selection.clearSelection}
                className="rounded px-2 py-0.5 hover:bg-indigo-100 transition-colors"
            >
                Clear
            </button>
        </div>
    );
};

// ── Line container ───────────────────────────────────────────────────────

const LineContainer: React.FC<{
    selection: LineSelectionState;
    spotlight: LineSpotlightState;
    className?: string;
    children: React.ReactNode;
}> = ({selection, spotlight, className, children}) => {
    return (
        <div ref={spotlight.containerRef} className={`line-viewer ${className ?? ''}`}>
            <SelectionBar selection={selection}/>
            <div className="line-viewer__lines">
                {children}
            </div>
        </div>
    );
};

export default LineContainer;
export {SelectionBar};
